import { DamageCostEvaluationDto, DamageCostEvaluationReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type DamageCostEvaluationDtoAny = DamageCostEvaluationDto | DamageCostEvaluationReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type DamageCostEvaluationDtoAll = DamageCostEvaluationDto & DamageCostEvaluationReferenceDto;

export class DamageCostEvaluationMapper {}
